import { useGetAdviserProjectsSummaryQuery } from "../../../services/adviserdashboard/adviserDashboardSummaryApiEndpoints";


export const useGetAdviserProjectsSummary = () => {
    const userId = "277eb1b4-023f-47d9-87df-a63746f822cf"
    const { data, error, isLoading } = useGetAdviserProjectsSummaryQuery({ userId });

    return {
        data, error, isLoading
    }
}